// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@/fonts/DarkerGrotesque-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@/fonts/DarkerGrotesque-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@/fonts/DarkerGrotesque-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@/fonts/DarkerGrotesque-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@/fonts/DarkerGrotesque-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@/assets/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #1F2128;
  --secondary: #00000099;
  --primary-hover: #EEFDFF;
  --primary-selected: #EEFDFF;
  --primary-actived: #EEFDFF;
  --border-color: #E6E6E6;
  --text: #3b403c;
  --text-primary: #1EC3DB;
  --text-secondary: #71E3FF;
}
@font-face {
  font-family: Darker Grotesque;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: Darker Grotesque;
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: Darker Grotesque;
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: Darker Grotesque;
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: Darker Grotesque;
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
html,
body,
#app {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  font-family: Darker Grotesque !important;
}
body {
  position: relative;
  overflow: hidden;
}
.scroll-x {
  overflow-x: auto;
}
.scroll-y {
  overflow-y: auto;
}
.scroll-opacity::-webkit-scrollbar {
  width: 0;
}
.scroll-opacity::-webkit-scrollbar-thumb {
  background-color: transparent;
}
.scroll-opacity::-webkit-scrollbar-track-piece {
  background-color: transparent;
}
.line-one {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.65);
}
.ant-modal .ant-modal-content {
  background-color: transparent;
  padding: 0;
}
.ant-modal .ant-modal-content .ant-modal-body {
  padding: 0;
}
.ant-modal-content {
  box-shadow: none !important;
}
.rp_message .rp_message-notice-content {
  background-color: #EAEBEC;
  color: #232323;
  box-shadow: none;
}
.rp_message .rp_message-notice-content > div {
  display: flex;
  align-items: center;
  font-size: 14px;
}
.rp_message .rp_message-notice-content > div > img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
@media screen and (max-width: 452px) {
  html {
    font-size: 1vw;
  }
}
@media screen and (min-width: 453px) {
  html {
    font-size: 4.06px;
  }
  body {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;AACJ;AAGA;EACI,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AADJ;AAIA;EACI,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AAFJ;AAKA;EACI,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AAHJ;AAMA;EACI,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AAJJ;AAOA;EACI,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;AALJ;AAQA;;;EAGI,YAAA;EACA,8IAAA;EAEA,wCAAA;AAPJ;AAUA;EACI,kBAAA;EACA,gBAAA;AARJ;AAWA;EACI,gBAAA;AATJ;AAYA;EACI,gBAAA;AAVJ;AAcI;EACI,QAAA;AAZR;AAeI;EACI,6BAAA;AAbR;AAgBI;EACI,6BAAA;AAdR;AAkBA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;AAhBJ;AAmBA;EACI,qCAAA;AAjBJ;AAoBA;EACI,6BAAA;EACA,UAAA;AAlBJ;AAqBA;EACI,UAAA;AAnBJ;AAsBA;EACI,2BAAA;AApBJ;AAuBA;EAEQ,yBAAA;EACA,cAAA;EACA,gBAAA;AAtBR;AAkBA;EAMY,aAAA;EACA,mBAAA;EACA,eAAA;AArBZ;AAaA;EAUgB,WAAA;EACA,YAAA;EACA,iBAAA;AApBhB;AA0BA;EACI;IACI,cAAA;EAxBN;AACF;AA2BA;EACI;IACI,iBAAA;EAzBN;EA4BE;IACI,yDAAA;IACA,2BAAA;IACA,4BAAA;IACA,sBAAA;EA1BN;AACF","sourcesContent":[":root {\n    --primary: #1F2128;\n    --secondary: #00000099;\n    --primary-hover: #EEFDFF;\n    --primary-selected: #EEFDFF;\n    --primary-actived:#EEFDFF;\n    --border-color: #E6E6E6;\n    --text: #3b403c;\n    --text-primary: #1EC3DB;\n    --text-secondary: #71E3FF;\n\n}\n\n@font-face {\n    font-family: Darker Grotesque;\n    font-style: normal;\n    font-weight: 400;\n    src: url(~@/fonts/DarkerGrotesque-Regular.ttf) format(\"truetype\");\n}\n\n@font-face {\n    font-family: Darker Grotesque;\n    font-style: normal;\n    font-weight: 500;\n    src: url(~@/fonts/DarkerGrotesque-Medium.ttf) format(\"truetype\");\n}\n\n@font-face {\n    font-family: Darker Grotesque;\n    font-style: normal;\n    font-weight: 600;\n    src: url(~@/fonts/DarkerGrotesque-SemiBold.ttf) format(\"truetype\");\n}\n\n@font-face {\n    font-family: Darker Grotesque;\n    font-style: normal;\n    font-weight: 700;\n    src: url(~@/fonts/DarkerGrotesque-Bold.ttf) format(\"truetype\");\n}\n\n@font-face {\n    font-family: Darker Grotesque;\n    font-style: normal;\n    font-weight: 800;\n    src: url(~@/fonts/DarkerGrotesque-ExtraBold.ttf) format(\"truetype\");\n}\n\nhtml,\nbody,\n#app {\n    height: 100%;\n    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,\n        Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n    font-family: Darker Grotesque !important;\n}\n\nbody {\n    position: relative;\n    overflow: hidden;\n}\n\n.scroll-x {\n    overflow-x: auto;\n}\n\n.scroll-y {\n    overflow-y: auto;\n}\n\n.scroll-opacity {\n    &::-webkit-scrollbar {\n        width: 0\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: transparent\n    }\n\n    &::-webkit-scrollbar-track-piece {\n        background-color: transparent\n    }\n}\n\n.line-one {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.ant-modal-mask {\n    background-color: rgba(0, 0, 0, .65)\n}\n\n.ant-modal .ant-modal-content {\n    background-color: transparent;\n    padding: 0\n}\n\n.ant-modal .ant-modal-content .ant-modal-body {\n    padding: 0\n}\n\n.ant-modal-content {\n    box-shadow: none !important\n}\n\n.rp_message {\n    .rp_message-notice-content {\n        background-color: #EAEBEC;\n        color: #232323;\n        box-shadow: none;\n        > div {\n            display: flex;\n            align-items: center;\n            font-size: 14px;\n            > img {\n                width: 24px;\n                height: 24px;\n                margin-right: 8px\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 452px) {\n    html {\n        font-size: 1vw;\n    }\n}\n\n@media screen and (min-width: 453px) {\n    html {\n        font-size: 4.06px;\n    }\n\n    body {\n        background-image: url(~@/assets/bg.png);\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
